export default {
  title: 'Restaurante de test',
  description:
    'Fiecare partener poate marca un restaurant ca restaurant de test. Funcționează ca orice alt restaurant și nu este facturat niciodată. O alertă Slack este trimisă când vânzările sale lunare depășesc pragul.',
  empty: 'Niciun partener nu are un restaurant de test.',
  columns: {
    partner: 'Partener',
    restaurant: 'Restaurant',
    designated: 'Marcat ca test',
    gmv: 'GMV luna aceasta',
  },
  statuses: {
    live: 'Live',
    paused: 'Offline',
    suspended: 'Suspendat',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Nu este stocat niciun curs de schimb',
  },
  actions: {
    remove: 'Elimină marcajul de Test',
  },
  toasts: {
    load_error: 'Restaurantele de test nu au putut fi încărcate.',
  },
};
